import React, { useState, useRef } from "react";
import { ProgressBar, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import config from "../config.json";
import http from '../Services/httpService';


export default function VideoUploadPage() {
  // اطلاعات کاربر
  const [fullName, setFullName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [instagramId, setInstagramId] = useState("");
  const [description, setDescription] = useState("");

  // اطلاعات و پیش‌نمایش فایل
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  // وضعیت آپلود و پروگرس
  const [isDoPosting, setIsDoPosting] = useState(false);
  const [progress, setProgress] = useState(0);
  const [uploadedSize, setUploadedSize] = useState("0");
  const [totalSize, setTotalSize] = useState("0");
  const [isSuccess, setIsSuccess] = useState(false);

  const fileInputRef = useRef(null);

  // انتخاب فایل
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile.size > 120 * 1024 * 1024) {
        toast.error("حجم فایل انتخابی بیش از حد مجاز (حداکثر ۱۲۰ مگابایت) است", { theme: "colored" });
        return;
      }
      setFile(selectedFile);
      setTotalSize((selectedFile.size / (1024 * 1024)).toFixed(1));
      setPreviewUrl(URL.createObjectURL(selectedFile));
    }
  };

  // حذف فایل
  const handleRemoveFile = () => {
    setFile(null);
    setPreviewUrl(null);
    setProgress(0);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  // ارسال فرم
 // ... سایر ایمپورت‌ها
const handleDo = async (e) => {
  e.preventDefault();

  // ۱. اعتبارسنجی فیلدها در فرانت‌اند
  if (!fullName.trim()) {
    toast.error("لطفاً نام و نام خانوادگی خود را وارد کنید", { theme: "colored" });
    return;
  }

  const mobileRegex = /^09[0-9]{9}$/;
  if (!mobileNumber.trim() || !mobileRegex.test(mobileNumber.trim())) {
    toast.error("لطفاً شماره موبایل معتبر (۰۹xxxxxxxxx) وارد کنید", { theme: "colored" });
    return;
  }

  if (!instagramId.trim()) {
    toast.error("وارد کردن آیدی اینستاگرام جهت بررسی تگ الزامی است", { theme: "colored" });
    return;
  }

  if (!file) {
    toast.error("لطفاً فایل ویدئو یا عکس خود را انتخاب کنید", { theme: "colored" });
    return;
  }

  setIsDoPosting(true);
  setProgress(0);

  const formData = new FormData();
  formData.append("FullName", fullName.trim());
  formData.append("MobileNumber", mobileNumber.trim());
  formData.append("InstagramId", instagramId.trim());
  formData.append("Description", description.trim());
  formData.append("File", file);

  const xhr = new XMLHttpRequest();

  xhr.upload.addEventListener("progress", (event) => {
    if (event.lengthComputable) {
      const percent = Math.round((event.loaded * 100) / event.total);
      setProgress(percent);
      setUploadedSize((event.loaded / (1024 * 1024)).toFixed(1));
    }
  });

  xhr.addEventListener("load", () => {
    setIsDoPosting(false);
    try {
      const data = JSON.parse(xhr.responseText);

      // بررسی وضعیت پاسخ بر اساس الگو اختصاصی شما
      if (data?.errorCode !== 0) {
        toast.error(data?.message || 'خطا در ثبت اطلاعات کمپین', { theme: "colored" });
        return;
      }

      // اگر errorCode صفر بود (موفقیت)
      toast.success(data?.message || "درخواست شما با موفقیت ثبت شد", { theme: "colored" });
      setIsSuccess(true);
      
    } catch (err) {
      toast.error("خطا در تحلیل پاسخ سرور", { theme: "colored" });
    }
  });

  xhr.addEventListener("error", () => {
    setIsDoPosting(false);
    toast.error("خطای ارتباط با سرور رخ داده است", { theme: "colored" });
  });

  xhr.open("POST", `${config.apiUrl}/api/CampaignFeedback/Upload`, true); // آدرس را مطابق Route کنترلر تنظیم کنید
  xhr.send(formData);
};


  return (
    <div className="min-vh-100 py-3 py-md-5 d-flex align-items-center justify-content-center" 
         style={{ background: "#f8fafc" }} 
         dir="rtl">
      
      <div 
        className="card border-0 shadow-lg mx-auto w-100" 
        style={{ maxWidth: "460px", borderRadius: "28px", overflow: "hidden", backgroundColor: "#ffffff" }}
      >
        {/* هدر نارنجی رنگ نورون */}
        <div 
          className="text-white text-center position-relative p-4"
          style={{ 
            background: "linear-gradient(145deg, #ff8438 0%, #ff4b00 100%)",
            boxShadow: "0 8px 24px rgba(255, 75, 0, 0.25)"
          }}
        >
          <div 
            className="d-inline-flex align-items-center justify-content-center mb-3 shadow"
            style={{
              width: "70px",
              height: "70px",
              borderRadius: "22px",
              background: "rgba(255, 255, 255, 0.22)",
              backdropFilter: "blur(8px)",
              fontSize: "32px"
            }}
          >
            ▶️
          </div>

          <h1 className="fw-black fs-4 mb-2">
            فقط با یک ویدئو، <span style={{ color: "#ffe259" }}>۳۰٪ تخفیف</span> بگیرید!
          </h1>
          <p className="small mb-0 text-white-50 px-2" style={{ lineHeight: "1.7" }}>
            تجربه کاربری خود را در قالب ویدئو یا تصویر ثبت کنید و کد تخفیف دریافت نمایید.
          </p>
        </div>

        <div className="card-body p-4">
          {isSuccess ? (
            /* صفحه تایید نهایی */
            <div className="text-center py-4">
              <div 
                className="d-inline-flex align-items-center justify-content-center mb-3 shadow-sm"
                style={{ width: "80px", height: "80px", borderRadius: "50%", background: "#e8f8f0", color: "#0fa958", fontSize: "38px" }}
              >
                ✓
              </div>
              <h4 className="fw-bold text-dark mb-2">اطلاعات شما با موفقیت ثبت شد!</h4>
              
              <div 
                className="p-3 my-3 text-start small rounded-3" 
                style={{ background: "#f0fdf4", border: "1px dashed #86efac", color: "#166534", lineHeight: "1.8" }}
              >
                <div className="fw-bold mb-1">⏱️ زمان‌بندی بررسی:</div>
                ویدیو ارسالی شما <strong>حداکثر ظرف ۲۴ ساعت</strong> بررسی شده و کد تخفیف به شماره موبایل <strong>{mobileNumber}</strong> پیامک خواهد شد.
              </div>

              <button 
                className="btn btn-outline-secondary w-100 py-2 rounded-pill mt-2 fw-medium"
                onClick={() => {
                  setIsSuccess(false);
                  handleRemoveFile();
                  setFullName("");
                  setMobileNumber("");
                  setInstagramId("");
                  setDescription("");
                }}
              >
                ارسال مجدد یا ویدئوی جدید
              </button>
            </div>
          ) : (
            <form onSubmit={handleDo}>
              {/* بنر اینستاگرام */}
              <div 
                className="p-3 rounded-4 mb-3 d-flex align-items-center gap-3"
                style={{ background: "#fff4ee", border: "1px solid #fed7aa" }}
              >
                <div 
                  className="d-flex align-items-center justify-content-center rounded-3 shadow-sm flex-shrink-0"
                  style={{
                    width: "42px",
                    height: "42px",
                    background: "linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)",
                    color: "#fff",
                    fontSize: "20px"
                  }}
                >
                  📷
                </div>
                <div className="small" style={{ lineHeight: "1.6", color: "#7c2d12" }}>
                  یک ویدئو بگیرید، در اینستاگرام منتشر و پیج <strong className="text-dark">noroncar@</strong> را تگ کنید.
                </div>
              </div>

              {/* باکس راهنما */}
              <div className="p-3 rounded-4 mb-3" style={{ background: "#f8fafc", border: "1px solid #e2e8f0" }}>
                <div className="fw-bold small text-dark mb-2">💡 مراحل دریافت تخفیف:</div>
                <div className="d-flex flex-column gap-2 small text-secondary">
                  <div className="d-flex align-items-start gap-2">
                    <span className="badge rounded-pill bg-warning text-dark px-2">1</span>
                    <span>ویدئویی کوتاه از رضایت و تجربه با نورون بگیرید.</span>
                  </div>
                  <div className="d-flex align-items-start gap-2">
                    <span className="badge rounded-pill bg-warning text-dark px-2">2</span>
                    <span>در پیج خود استوری یا پست کرده و ما را تگ کنید.</span>
                  </div>
                  <div className="d-flex align-items-start gap-2">
                    <span className="badge rounded-pill bg-warning text-dark px-2">3</span>
                    <span>فرم زیر را تکمیل و ویدیو را بارگذاری کنید.</span>
                  </div>
                </div>
                <div className="mt-2 pt-2 border-top text-muted" style={{ fontSize: "11px" }}>
                  ⏱️ <strong>بررسی ۲۴ ساعته:</strong> کد تخفیف حداکثر ظرف ۲۴ ساعت برای شماره موبایل شما ارسال خواهد شد.
                </div>
              </div>

              {/* فیلدهای مشخصات کاربر */}
              <div className="row g-2 mb-3">
                <div className="col-12 col-md-6">
                  <label className="form-label small fw-bold text-secondary mb-1">
                    نام و نام خانوادگی <span className="text-danger">*</span>
                  </label>
                  <input 
                    type="text" 
                    className="form-control shadow-none rounded-3"
                    placeholder="مثال: علی محمدی"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                    disabled={isDoPosting}
                    required
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label small fw-bold text-secondary mb-1">
                    شماره موبایل <span className="text-danger">*</span>
                  </label>
                  <input 
                    type="tel" 
                    dir="ltr"
                    maxLength="11"
                    className="form-control text-center shadow-none rounded-3"
                    placeholder="09123456789"
                    value={mobileNumber}
                    onChange={(e) => setMobileNumber(e.target.value)}
                    disabled={isDoPosting}
                    required
                  />
                </div>
              </div>

              {/* باکس آپلود فایل */}
              <div className="mb-3">
                <label className="form-label small fw-bold text-secondary mb-2">
                  ویدئو یا تصویر ارسالی <span className="text-danger">*</span>
                </label>
                
                {!previewUrl ? (
                  <div 
                    onClick={() => fileInputRef.current.click()}
                    className="p-4 text-center rounded-4"
                    style={{ border: "2px dashed #fb923c", backgroundColor: "#fffaf5", cursor: "pointer" }}
                  >
                    <div className="mb-2" style={{ fontSize: "34px" }}>☁️</div>
                    <div 
                      className="btn text-white fw-bold px-4 py-2 rounded-pill shadow-sm mb-2"
                      style={{ background: "linear-gradient(135deg, #ff7a18 0%, #ff5200 100%)", border: "none" }}
                    >
                      انتخاب ویدئو 📤
                    </div>
                    <div className="text-muted" style={{ fontSize: "12px" }}>
                      پشتیبانی از انواع فایل ویدئو یا عکس (حداکثر ۱۲۰ مگابایت)
                    </div>
                  </div>
                ) : (
                  <div className="position-relative rounded-4 overflow-hidden border p-2 bg-dark text-center shadow-sm">
                    {file && file.type.startsWith("video") ? (
                      <video src={previewUrl} controls className="w-100 rounded-3" style={{ maxHeight: "200px" }} />
                    ) : (
                      <img src={previewUrl} alt="Preview" className="w-100 rounded-3" style={{ maxHeight: "200px", objectFit: "contain" }} />
                    )}
                    <button 
                      type="button" 
                      onClick={handleRemoveFile}
                      className="btn btn-danger btn-sm rounded-circle position-absolute top-0 end-0 m-3 shadow"
                      style={{ width: "32px", height: "32px", padding: 0 }}
                    >
                      ✕
                    </button>
                    <div className="d-flex justify-content-between text-white-50 px-2 mt-2" style={{ fontSize: "11px" }}>
                      <span className="text-truncate" style={{ maxWidth: "200px" }}>{file?.name}</span>
                      <span>{totalSize} MB</span>
                    </div>
                  </div>
                )}
                <input 
                  type="file" 
                  ref={fileInputRef} 
                  onChange={handleFileChange} 
                  accept="video/*,image/*" 
                  className="d-none" 
                />
              </div>

              {/* نوار وضعیت درصد و مگابایت آپلود */}
              {isDoPosting && (
                <div className="p-3 rounded-4 mb-3" style={{ background: "#fff7ed", border: "1px solid #ffedd5" }}>
                  <div className="d-flex justify-content-between small fw-bold mb-1" style={{ color: "#9a3412" }}>
                    <span>در حال بارگذاری فایل...</span>
                    <span>{progress}%</span>
                  </div>
                  <ProgressBar 
                    now={progress} 
                    animated 
                    style={{ height: "8px", borderRadius: "10px", backgroundColor: "#fed7aa" }} 
                    variant="warning"
                  />
                  <div className="d-flex justify-content-between text-muted mt-2" style={{ fontSize: "11px" }}>
                    <span>ارسال‌شده: {uploadedSize} مگابایت</span>
                    <span>کل فایل: {totalSize} مگابایت</span>
                  </div>
                </div>
              )}

              {/* آیدی اینستاگرام */}
              <div className="mb-3">
                <label className="form-label small fw-bold text-secondary mb-1">آیدی اینستاگرام (جهت بررسی تگ)</label>
                <div className="input-group">
                  <span className="input-group-text bg-light text-muted border-end-0 rounded-end-3">@</span>
                  <input 
                    type="text" 
                    dir="ltr"
                    className="form-control border-start-0 shadow-none rounded-start-3"
                    placeholder="Instagram_id"
                    value={instagramId}
                    onChange={(e) => setInstagramId(e.target.value)}
                    disabled={isDoPosting}
                  />
                </div>
              </div>

              {/* توضیحات */}
              <div className="mb-4">
                <div className="d-flex justify-content-between mb-1">
                  <label className="form-label small fw-bold text-secondary mb-0">توضیحات کوتاه (اختیاری)</label>
                  <span className="text-muted" style={{ fontSize: "11px" }}>{description.length}/300</span>
                </div>
                <textarea 
                  className="form-control shadow-none rounded-3" 
                  rows="2" 
                  maxLength="300"
                  placeholder="تجربه کار با سامانه یا ردیاب..."
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  disabled={isDoPosting}
                  style={{ fontSize: "13px" }}
                ></textarea>
              </div>

              {/* دکمه ارسال */}
              <button 
                type="submit" 
                className="btn w-100 py-3 text-white fw-bold shadow"
                disabled={isDoPosting}
                style={{ 
                  background: "linear-gradient(135deg, #ff7a18 0%, #ff4b00 100%)", 
                  borderRadius: "16px",
                  border: "none",
                  fontSize: "15px"
                }}
              >
                {isDoPosting ? (
                  <div className="d-flex align-items-center justify-content-center gap-2">
                    <Spinner animation="border" size="sm" />
                    <span>در حال بارگذاری فایل ({progress}%)...</span>
                  </div>
                ) : (
                  <span>ثبت درخواست و ارسال ویدئو 🎁</span>
                )}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
